export default __webpack_public_path__ + "static/media/lighting.2458f5f0.svg";